// extracted by css-extract-rspack-plugin
export default {"root":"u4QCTa","footnote":"JqBefj"};